module.exports = __webpack_public_path__ + "img/artisia.1ee9c20f.png";